import { styled, Typography } from "@mui/material";
import Image from "next/legacy/image";
import { FunctionComponent } from "react";
import { useTranslation } from "../../helpers/i18n";

interface Props {
  backgroundColor?: string;
  textColor?: string;
  logo?: string;
  description?: string;
  title?: string;
  marketplaceName?: string;
}

const Container = styled("div")<Pick<Props, "backgroundColor">>(
  ({ backgroundColor }) => ({
    display: "flex",
    backgroundColor,
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    textAlign: "center",
    width: "100%",
    height: "100%",
    padding: "5rem",
  }),
);

const Title = styled(Typography)<Pick<Props, "textColor">>(
  ({ theme, textColor }) => ({
    marginTop: "7.5rem",
    marginBottom: "2rem",
    color: textColor,
    textAlign: "left",
    fontSize: theme.typography.h3.fontSize,
  }),
);

const Description = styled(Typography)<Pick<Props, "textColor">>(
  ({ textColor }) => ({
    color: textColor,
    textAlign: "left",
  }),
);
const StaticGraphic: FunctionComponent<Props> = ({
  backgroundColor,
  textColor,
  logo,
  description,
  marketplaceName,
  title,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Container backgroundColor={backgroundColor}>
      <Image
        quality={100}
        width={200}
        height={200}
        alt={`${marketplaceName} ${t("accessibility_logo_alt_text")}`}
        src={logo || ""}
      />
      <Title textColor={textColor} variant="h1">
        {title}
      </Title>
      <Description textColor={textColor}>{description}</Description>
    </Container>
  );
};
export default StaticGraphic;
